import { render, staticRenderFns } from "./Write.vue?vue&type=template&id=2dff2ae6&scoped=true"
import script from "./Write.vue?vue&type=script&lang=js"
export * from "./Write.vue?vue&type=script&lang=js"
import style0 from "./Write.vue?vue&type=style&index=0&id=2dff2ae6&prod&scoped=true&lang=scss"
import style1 from "./Write.vue?vue&type=style&index=1&id=2dff2ae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff2ae6",
  null
  
)

export default component.exports